import React from 'react';
import { ChevronRight } from 'lucide-react';
import { useQuery, useMutation } from '@apollo/client';
import PropTypes from 'prop-types';

import { C } from '../constants/theme';
import { GOALS } from '../constants/data';
import { Btn, CheckBox, Heading, IconBox, OptionCard, Sub, Tag } from '../components';
import { toggleArr } from '../helpers';
import { SET_HEALTH_GOALS } from 'core/api/apollo/mutations';
import { LIST_HEALTH_GOALS } from 'core/api/apollo/queries';
import Loading from 'core/ui/components/Loading';
import { isLoading } from 'core/api/loadingHelpers';
import useUser from 'core/hooks/useUser';
import { useProgramContext } from 'core/api/programContext';

const Phase1Goals = ({ goPhase }) => {
  const { goals, setGoals } = useProgramContext();
  const { currentUser } = useUser();
  const { loading, data: { listHealthGoals = [] } = {} } = useQuery(LIST_HEALTH_GOALS);

  const [setHealthGoals] = useMutation(SET_HEALTH_GOALS, {
    onCompleted: async (data) => {
      // eslint-disable-next-line no-console
      console.log('Health goals set successfully:', data);
      goPhase(2);
    },
    onError: (error) => {
      // eslint-disable-next-line no-console
      console.error('Error in set health goals:', error);
    },
  });

  const handleSetHealthGoals = async () => {
    try {
      await setHealthGoals({
        variables: {
          input: {
            healthGoalIds: goals,
          },
        },
      });
    } catch (error) {
      console.error('Failed to set health goals:', error);
    }
  };

  if (isLoading(loading, listHealthGoals)) {
    return <Loading />;
  }

  const RenderGoals = () => listHealthGoals && listHealthGoals.map((goal) => {
    return (
      <OptionCard key={goal.id} active={goals.includes(goal.id)} onClick={() => toggleArr(goals, setGoals, goal.id, 1)}>
        <IconBox name={goal.icon} active={goals.includes(goal.id)} size={16}/>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: C.darkBrown }}>
            {goal.name}
          </div>
          <div style={{ fontSize: 10.5, color: C.lightBrown, marginTop: 1 }}>{goal.description}</div>
        </div>
        <CheckBox active={goals.includes(goal.id)}/>
      </OptionCard>
    );
  });

  return <>
    <style>{`
      .m-goals-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
      @media (max-width: 480px) { .m-goals-grid { grid-template-columns: 1fr; } }
    `}</style>
    <Heading>What are you optimizing for, {currentUser?.firstName}?</Heading>
    <Sub>Pick your most important goal. This directly weights which meals the algorithm prioritizes for you.</Sub>
    <div className="m-goals-grid">
      <RenderGoals />
    </div>
    {goals.length > 0 &&
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 12 }}>
        {goals.map((g) => <Tag key={g}>{GOALS.find((x) => x.id === g)?.admin_name}</Tag>)}
      </div>
    }
    <Btn onClick={handleSetHealthGoals} disabled={goals.length === 0} style={{ width: '100%', marginTop: 16 }}>
      Continue <ChevronRight size={15}/>
    </Btn>
  </>;
};

Phase1Goals.propTypes = {
  goPhase: PropTypes.func.isRequired,
};

export default Phase1Goals;
